var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2423 95H100.429C101.296 95 102 94.2877 102 93.4091V61.5909C102 61.4822 101.989 61.3761 101.969 61.2736L88.5153 74.727L96.4531 84.9387C96.8191 85.42 96.8807 86.0673 96.6121 86.6091C96.3446 87.1554 95.7891 87.5013 95.1811 87.5H75.7423L68.2423 95ZM85.4228 70.7485L85.3233 70.6205C85.0197 70.2259 84.549 69.9963 84.0514 70C83.5509 70 83.0796 70.2359 82.7794 70.6365L76.5467 79.1001L73.9709 76.841C73.644 76.5552 73.2144 76.4156 72.782 76.4547C72.3496 76.4937 71.9519 76.708 71.6814 77.0478L65.3215 85.0023C64.9762 85.4595 64.9033 86.0672 65.1307 86.5932C65.3937 87.1457 65.9501 87.4983 66.5617 87.5H68.6712L61.1713 95H59.5714C58.7036 95 58 94.2877 58 93.4091V61.5909C58 60.7123 58.7036 60 59.5714 60H96.1713L85.4228 70.7485ZM74.3333 68.75C74.3333 66.6789 72.6917 65 70.6667 65C68.6416 65 67 66.6789 67 68.75C67 70.8211 68.6416 72.5 70.6667 72.5C72.6917 72.5 74.3333 70.8211 74.3333 68.75Z",
    fill: "#7783A1",
    fillOpacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 101.255,
    width: 64,
    height: 2,
    rx: 1,
    transform: "rotate(-45 57 101.255)",
    fill: "#7783A1",
    fillOpacity: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.82366195cc8a232549e82d63c71283f7.svg";
export { ForwardRef as ReactComponent };